<script setup lang="ts">
defineProps({
  value: {
    type: Number,
    required: true
  }
});
</script>
<template>
  <div class="card">
    <div class="card-body">
      <div>
        <div class="fs-4 fw-semibold">
          <span>{{ $t("components.queue_throughput.value", {n: value}) }}</span>
        </div>
        <div>{{ $t("components.queue_throughput.text") }}</div>
      </div>
    </div>
  </div>
</template>
